import { useEffect } from 'react';

export const useAutoFocus = id => {
  useEffect(() => {
    let t = setInterval(() => {
      const input = document.getElementById(id);
      if (input) {
        input.focus();
        clearInterval(t);
      }
    }, 300);

    return () => clearInterval(t);
  }, [id]);
};
